import { Box, Flex, Text, useToast } from '@chakra-ui/react'
import React, { useState } from 'react'
import Bg from './bg.png'
import CustomInput from '../../components/customInput/customInput'
import { useParams } from 'react-router-dom'
import PrimaryButton from '../../components/primaryButton/primarybutton'
import axios from 'axios'

const AdForm = () => {
  const { role } = useParams()

  const roles = ["Promoter", "Supervisor"]
  const toast = useToast()

  const [loading, setLoading] = useState(false)
  const [payload, setPayload] = useState({
    firstName: '',
    lastName: '',
    email: '',
    role: (role === 'promoter' ? 'Promoter' : role === 'supervisor' ? 'Supervisor' : role) || ''
  })

  const handleSubmit = async(e) => {
    e.preventDefault()
    setLoading(true)
    try {
        const {data} = await axios.post('https://api.thepromorama.com/api/v1/leads', payload);
        toast({
            description: data?.message,
            status: "success",
            position: "top-right",
            duration: 5000,
            isClosable: true,
          });
          setPayload({
            firstName: '',
            lastName: '',
            email: '',
            role: role || ''
          })
    } catch(error) {
        toast({
            title: "An Error Occurred",
            description: error?.response?.data?.message,
            status: "error",
            position: "top-right",
            duration: 5000,
            isClosable: true,
          });
    } finally {
         setLoading(false)
    }
  }

  return (
    <Flex height={"600px"} pt="4.5rem" flexWrap={"wrap"}>
        <Box flex={"1"} backgroundImage={Bg} backgroundSize={'cover'} display={["none", "none", "flex"]} />
        <Flex flex={"1"} bg="#FFF" alignItems={"center"} px="10px">
            <Box maxW={"700px"} mx="auto">
                <Text fontWeight={"600"} fontSize={"1.2rem"}>Interested in joining us?</Text>
                <Text fontWeight={"500"} fontSize={".9rem"} opacity={".7"}>Provide the following information to get started</Text>

                {!role &&
                <Flex gap="1rem" alignItems={"center"} mt="2rem">
                {roles.map(i => (
                    <Text key={i} onClick={() => setPayload({...payload, role: i})} p=".5rem 1rem" borderRadius={"6px"} cursor={"pointer"} flex={"1"} textAlign={"center"} border={payload?.role === i ? "2px solid purple" : "2px solid #C7CBD1"}>{i}</Text>
                ))}
                </Flex>}
                
                <form onSubmit={handleSubmit}>
                    <Flex gap="1rem" mt="1.5rem">
                        <CustomInput placeholder="First Name" type={'text'} py="1rem" value={payload?.firstName} onChange={e => setPayload({...payload, firstName: e.target.value})} />
                        <CustomInput placeholder="Last Name" type={'text'} py="1rem" value={payload?.lastName} onChange={e => setPayload({...payload, lastName: e.target.value})} />
                    </Flex>
                    <CustomInput placeholder="Email Address" type={'email'} py="1rem" value={payload?.email} onChange={e => setPayload({...payload, email: e.target.value})} />
                    <PrimaryButton text="Submit" type="submit" mt="1.5rem" loading={loading}  />
                </form>
            </Box>
        </Flex>
    </Flex>
  )
}

export default AdForm;